import type { MobilisationEvent } from '@hcc/types';
import { PreAssignedKitPanel } from '../../../components/person/PreAssignedKitPanel';
import { KitReceiptsPanel } from '../../../components/person/KitReceiptsPanel';
import { ResendCertificatePanel } from '../../../components/person/ResendCertificatePanel';
import type { PersonApi } from './types';

export function KitTab({
  person,
  events,
}: {
  person: PersonApi;
  events: MobilisationEvent[] | null;
}) {
  return (
    <>
      <PreAssignedKitPanel personId={person.id} personName={person.full_name} />
      <KitReceiptsPanel personId={person.id} events={events} />
      <ResendCertificatePanel
        personId={person.id}
        fullName={person.full_name}
        email={person.email}
      />
    </>
  );
}
